export enum Storage {
  CreditasAffiliatesToken = 'creditas-affiliates-token',
  CreditasAffiliatesTokenExpires = 'creditas-affiliates-expires',
  CreditasAjsUserTraits = 'ajs_user_traits',
}
